import {createRoot} from 'react-dom/client'
import {Provider} from 'react-redux'
import {store} from './app/store'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'

import {GoogleOAuthProvider} from '@react-oauth/google'
import {HelmetProvider} from 'react-helmet-async'

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'

/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {Toaster} from 'react-hot-toast'
import {ErrorFallback} from './app/modules/errors/components/ErrorFallback'
import {ErrorBoundary} from 'react-error-boundary'
import {getLogoByHost} from './app/modules/config'
import Unauthorized from './app/utils/components/Unauthorized'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)

const clientID = '244303874385-j9phjnightjntk05uppedlcj2s456p3f.apps.googleusercontent.com'
// 244303874385-j9phjnightjntk05uppedlcj2s456p3f.apps.googleusercontent.com
// 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
const clientSecret = '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'

const iconPath = getLogoByHost().favIcon

const favicon = document.querySelector("link[rel='shortcut icon']") as HTMLLinkElement

if (favicon) {
  favicon.href = iconPath
}

// const isUnauthorized = window.location.hostname === 'localhost'
const isUnauthorized = false

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        const status = error?.response?.status

        // DO NOT retry on 401 (Unauthorized)
        if (status === 401) return false

        // Retry only for server errors (5xx)
        if (status >= 500 && failureCount < 3) return true

        // Otherwise, do not retry
        return false
      },
    },
    mutations: {
      retry: false, // No retry for POST/PUT/DELETE errors
    },
  },
})
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <HelmetProvider>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={(error, info) => {
          console.error('Caught by ErrorBoundary:', error, info)
        }}
      >
        {isUnauthorized ? (
          <Unauthorized />
        ) : (
          <QueryClientProvider client={queryClient}>
            <MetronicI18nProvider>
              <Provider store={store}>
                <GoogleOAuthProvider clientId={clientID}>
                  <AuthProvider>
                    <Toaster
                      position='top-center'
                      toastOptions={
                        {
                          // duration: 5000
                        }
                      }
                    />
                    <AppRoutes />
                  </AuthProvider>
                </GoogleOAuthProvider>
              </Provider>
            </MetronicI18nProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        )}
      </ErrorBoundary>
    </HelmetProvider>
  )
}
